import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import "./i18n";
import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom'

// After a deploy, cached HTML can request deleted JS chunks → blank page.
// One automatic reload recovers; avoid reload loops with sessionStorage.
window.addEventListener('error', function (event) {
  var msg = (event && event.message) || '';
  var isChunkError =
    msg.indexOf('Loading chunk') !== -1 ||
    msg.indexOf('ChunkLoadError') !== -1 ||
    (event && event.error && event.error.name === 'ChunkLoadError');
  if (!isChunkError) {
    return;
  }
  try {
    var key = 'hngpl_chunk_reload';
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, '1');
      window.location.reload(true);
    }
  } catch (e) {
    window.location.reload();
  }
});

ReactDOM.render(
  // <BrowserRouter basename="/">
  //   <App />
  // </BrowserRouter>

  <HashRouter basename="/">
    <App />
  </HashRouter>
, document.getElementById('root'));

serviceWorker.unregister();